import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Material from  '../Material'
import AnswerAnalysis from '../Material/AnswerAnalysis'
import styles from  './questions.css'

@observer(['practiceStore'])
export default class BlankQuestion extends Component {

  componentDidUpdate(){
  this.handleAddBlanksListener()
  }

  componentDidMount() {
    this.handleAddBlanksListener()
  }

  handleAddBlanksListener() {
    let blanks = this.refs.stemList.refs.stem.getElementsByClassName('blank')
    for (let i = 0; i < blanks.length; i++) {
      blanks[i].onchange = (e) => {
        this.handleChangeValue(e.target.value, i)
      }
    }
    this.setAnswerToHtml()
  }

  handleChangeValue(val, blankIndex) {
    const { practiceStore, questionIndex, choices } = this.props
    const userAnswer = practiceStore.userAnswer.toJSON()
    userAnswer[questionIndex][blankIndex].answer = val.trim()
    userAnswer[questionIndex][blankIndex].isCorrect = choices[blankIndex].content.indexOf(val) >= 0
    practiceStore.saveAnswer(userAnswer)
  }

  setAnswerToHtml() {
    const { practiceStore, questionIndex } = this.props
    const blankUserAnswer = practiceStore.userAnswer.toJSON()
    let blanks = this.refs.stemList.refs.stem.getElementsByClassName('blank')
    for (let i = 0; i < blanks.length; i++) {
      blanks[i].value = blankUserAnswer[questionIndex] ?
      blankUserAnswer[questionIndex][i].answer : []
    }
  }

  render() {
    const {
      practiceStore,
      question,
      answer_analysis,
      choices,
      category,
      isSingleLayout
    } = this.props

    return (
      <div>
        <Material
          stem={ question }
          ref="stemList"
          category={category}
          isSingleLayout={isSingleLayout}
        />
        { practiceStore.show.answer ?
          <div>
            <div className={styles.blankAnswer}>
              <span className={styles.answerItem}>正确答案</span>
              <div>
                {
                  choices.map((item,index)=> {
                    return (
                      <span key={index} className={styles.answerItem}>
                        {`${item.question_index}. ${item.content[0]}`}
                      </span>
                    )
                  })
                }
              </div>
            </div>
            <AnswerAnalysis analysisAnswer={ answer_analysis } />
          </div>
          : null
        }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Question/BlankQuestion.js
 **/